export const SELECT_LANGUAGE = 'SETTINGS_SELECT_LANGUAGE'
export const SET_LANGUAGES = 'SETTINGS_SET_LANGUAGES'
export const SET_SOUND_EFFECTS = 'SETTINGS_SET_SOUND_EFFECTS'
export const SET_SOUND_MUSIC = 'SETTINGS_SET_SOUND_MUSIC'
export const SET_SOUND_BACKGROUND = 'SETTINGS_SET_SOUND_BACKGROUND'
export const SET_SOUND_VOICES = 'SETTINGS_SET_SOUND_VOICES'
export const SET_MINE_DISCLAIMER = 'SETTINGS_SET_MINE_DISCLAIMER'
export const SYNC_SETTINGS_FROM_SAVEPOINT = 'SETTINGS_SYNC_SETTINGS_FROM_SAVEPOINT'
export const SHOW_HELP = 'SETTINGS_SHOW_HELP'
export const TOGGLE_SHADOWS = 'SETTINGS_TOGGLE_SHADOWS'

export const selectLanguage = (lang) => {
  return { type: SELECT_LANGUAGE, data: lang }
}
export const toggleShadows = () => {
  return { type: TOGGLE_SHADOWS }
}
export const setLanguages = (languages) => {
  return { type: SET_LANGUAGES, data: languages }
}
export const setSoundBackground = (sound) => {
  return { type: SET_SOUND_BACKGROUND, data: sound }
}
export const setSoundEffects = (sound) => {
  return { type: SET_SOUND_EFFECTS, data: sound }
}
export const setSoundVoices = (sound) => {
  return { type: SET_SOUND_VOICES, data: sound }
}
export const setSoundMusic = (sound) => {
  return { type: SET_SOUND_MUSIC, data: sound }
}
export const setMineDisclaimer = () => {
  return { type: SET_MINE_DISCLAIMER }
}
export const showHelp = () => {
  return { type: SHOW_HELP }
}
export const syncFromSavePoint = (settings) => {
  return { type: SYNC_SETTINGS_FROM_SAVEPOINT, data: settings }
}
